<template>
  <div class="wrapper">
    <div class="form">
      <ui5-title level="H2">{{ $t("login.resetPassword") }}</ui5-title>
      <PasswordForm
        cypressIdEmail="change_password_email"
        cypressIdPassword="password_new_input"
        cypressIdPasswordConfirm="password_confirm_input"
        cypressIdButton="change_password_btn"
        :buttonName="$t('login.resetPassword')"
        url="resetPassword"
        urlPost="setPassword" />
    </div>
  </div>
</template>

<script>
import PasswordForm from "../components/PasswordForm.vue";

export default {
    name: "ForgotPassword",
    components: {
        PasswordForm,
    },
};
</script>
